module.exports = __webpack_public_path__ + "img/final.0aba8ca6.png";